import { ChainId, DefaultChainId, RPC, SupportChainIDs } from '../constants';
import { action, autorun, makeAutoObservable } from 'mobx';
import Web3 from 'web3';

export function getCurrentChainId(): ChainId {
    const web3ChainId = Number(
        ((window as any)?.web3 as any)?.currentProvider.chainId,
    );

    return SupportChainIDs.indexOf(web3ChainId) >= 0
        ? web3ChainId
        : DefaultChainId;
}
export class User {
    isOpenConnectModal: boolean = false;
    isDark: boolean = true;
    web3: any;
    address: string = '';
    chainId: ChainId = getCurrentChainId();
    connected: boolean = false;
    isPolis: boolean = false;
    loadingUserInfo: boolean = false;
    showNoti: boolean = false;

    constructor() {
        makeAutoObservable<this>(this);
    }

    toggleConnectModal = () => {
        this.isOpenConnectModal = !this.isOpenConnectModal;
    };

    toggleTheme = () => {
        this.isDark = !this.isDark;
    };

    setWeb3 = (web3: any) => {
        this.web3 = web3;
    };

    setAddress = (address: string) => {
        this.address = address;
    };

    setConnected = (connected: boolean) => {
        this.connected = connected;
    };
    setChainId = (chainId: ChainId) => {
        this.chainId = chainId;
    };
    setLoadingUserInfo = (loading: boolean) => {
        this.loadingUserInfo = loading;
    };

    setIsPolis = (polis: boolean) => {
        this.isPolis = polis;
    };

    clearLoginInfo = () => {
        this.web3 = new Web3(
            new Web3.providers.HttpProvider(RPC[DefaultChainId]),
        );
        this.chainId = DefaultChainId;
        this.address = '';
        this.connected = false;
    };
}

export default new User();
